import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Button, Typography } from "@material-ui/core";
import { Delete, Cancel } from "@material-ui/icons";

import { deleteInternalResearch } from "../../../../reducer/internalResearch/action";

// DeleteForm — xác nhận xoá đề tài. Đơn giản, chỉ tên + 2 nút.
export default function DeleteForm({ detail, onDone }) {
  const dispatch = useDispatch();
  const [pending, setPending] = useState(false);

  const handleDelete = async () => {
    setPending(true);
    try {
      await dispatch(deleteInternalResearch(detail.id));
      if (onDone) onDone();
    } finally {
      setPending(false);
    }
  };

  return (
    <Box padding="16px 24px">
      <Typography variant="body1">
        Bạn có chắc muốn xoá đề tài:
      </Typography>
      <Box marginTop={1} padding={2} bgcolor="#fafafa" border="solid 1px #e0e0e0" borderRadius={4}>
        <Typography variant="body1"><b>{detail?.vietnameseName || detail?.title || "(không tên)"}</b></Typography>
      </Box>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: 12 }}>
        Hành động này không thể hoàn tác.
      </Typography>

      <Box marginTop={3} paddingTop={2} display="flex" gridGap={12} justifyContent="flex-end" borderTop="solid 1px #e0e0e0">
        <Button
          variant="outlined" startIcon={<Cancel />} disabled={pending}
          onClick={onDone}
        >
          Huỷ
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "#b52f2f", color: "#fff" }}
          startIcon={<Delete />} disabled={pending}
          onClick={handleDelete}
        >
          Xoá đề tài
        </Button>
      </Box>
    </Box>
  );
}
